// Every report-param key the answer variants block can persist, each set to null.

import { calcQuestionClearParams } from '@aytm/app/stats/page/question-views/components/lib/clear-params'

const QUESTION_PARAMS = ['cm', 'z', 's', 'cb', 'wc']
const SUB_ITEM_PARAMS = ['wc', 'oe', 'cm', 'z', 's']

export const calcClearParams = ({ questionKey, answerVariants, batches, clusters } = {}) =>
  calcQuestionClearParams({
    questionKey,
    answerVariants,
    batches,
    clusters,
    question: QUESTION_PARAMS,
    subItem: SUB_ITEM_PARAMS
  })
